import { defineComponent as _defineComponent } from 'vue';
import { fundSetupI18nText } from '../pages/portfolio/funds/edit/i18n';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralKpisIntro',
  setup: function setup(__props) {
    var currentLocale = getLocale();
    var text = computed(function () {
      return fundSetupI18nText.questions.generalMetricIds.intro[currentLocale];
    });
    return {
      __sfc: true,
      currentLocale: currentLocale,
      text: text
    };
  }
});